import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

interface PlanFormHeaderProps {
  onCreatePlan: () => void;
  isLoading: boolean;
}

export const PlanFormHeader = ({ onCreatePlan, isLoading }: PlanFormHeaderProps) => {
  return (
    <Button
      onClick={onCreatePlan}
      className="bg-clubbers-red hover:bg-clubbers-red/90 sunset:bg-[#ff5500] forest:bg-forest w-full sm:w-auto"
      disabled={isLoading}
    >
      <Plus className="mr-2 h-4 w-4" />
      {isLoading ? "Creando..." : "Crear Plan"}
    </Button>
  );
};